module.exports = __webpack_public_path__ + "images/vmleasing_small71dbb474806de1428332fd9ff6eb2ea1.png";